import React from "react";
import { Icon } from "@culturehq/components";

import styles from "./star-rating-average.module.scss";

type StarRatingAverageProps = {
  value: number;
};

const StarRatingAverage: React.FC<StarRatingAverageProps> = ({ value }) => (
  <div>
    <div
      className={styles.progress}
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={5}
      style={{ width: `${(value / 5) * 100}%` }}
    >
      <div className={styles.stars}>
        <Icon icon="star" />
        <Icon icon="star" />
        <Icon icon="star" />
        <Icon icon="star" />
        <Icon icon="star" />
      </div>
    </div>
  </div>
);

export default StarRatingAverage;
